import React from 'react';
import clsx from 'clsx';
import { useTranslation } from 'next-i18next';
import Dialog from '@components/atoms/dialog/dialog';
import Button from '@components/atoms/button/button';
import Icon from '@components/atoms/icon/icon';
import useWindowSize from '@hooks/use-window-size';
import { scrollToTop } from '@helpers/utils/general';

import styles from './seller-information-error-modal.module.scss';

const SellerInformationErrorModal = ({ isOpen, onClose }) => {
  const { t } = useTranslation('get-paid');
  const { isWiderThanMd } = useWindowSize();

  return (
    <>
      <button
        tabIndex={-1}
        onClick={() => isOpen}
      >
        <Dialog
          key="sellerInfoErrorModal"
          isOpen={isOpen}
          closeDialog={() => {
            onClose();
            scrollToTop();
          }}
          hasCloseIcon
          customClass={styles.sellerInfoErrorModaleWrapper}
          fullScreenOnMobile={false}
          styles={{
            content: {
              maxWidth: isWiderThanMd ? '500px' : '340px',
              width: '100%',
              padding: isWiderThanMd ? '2.5rem' : '1.5rem',
            },
          }}
        >
          {(modalDialogTitleId) => (
            <div className={styles.sellerInformationErrorModal}>
              <div className={styles.sellerInformationErrorModal__icon}>
                <Icon
                  name="warning-large"
                  ariaHidden
                />
              </div>
              <h2
                className={clsx(styles.sellerInformationErrorModal__title, 'vc-text-H20', 'vc-text-bold')}
                id={modalDialogTitleId}
              >
                {t('GET_PAID.TAX_INFORMATION_FORM.ERROR.GENERIC', 'Something went wrong')}
              </h2>
              <div className={clsx(styles.sellerInformationErrorModal__subtitle, 'vc-text-H16')}>
                {t('GET_PAID.TAX_INFORMATION_FORM.ERROR.SUBMIT_FAILED', 'Please check your information and try again.')}
              </div>
              <Button
                className={clsx(styles.sellerInformationErrorModal__cta, 'vc-text-l')}
                variant="primary"
                size="large"
                onClick={() => onClose()}
              >
                {t('GET_PAID.TAX_INFORMATION_FORM.OK_CTA', 'Ok')}
              </Button>
            </div>
          )}
        </Dialog>
      </button>
    </>
  );
};

export default SellerInformationErrorModal;
